<template>
  <div class="tree-select" :class="{ 'tree-line': isLine }">
    <treeselect
      v-if="normalizerFlag"
      :options="departMentTree"
      v-model="defaultValue"
      :defaultExpandLevel="defaultExpandLevel"
      :alwaysOpen="alwaysOpen"
      :openDirection="openDirection"
      :clearable="clearable || true"
      :multiple="multiple"
      :disabled="disabled"
      :flat="flat"
      :maxHeight="200"
      @select="selectNode"
      @input="inputNode"
      :placeholder="$t('company.treeselect.searchIndex')"
      :noResultsText="$t('company.treeselect.noData')"
      :searchPromptText="$t('company.treeselect.searchIndex')"
      :normalizer="normalizer"
    />
    <treeselect
      v-else
      :options="departMentTree"
      v-model="defaultValue"
      :alwaysOpen="alwaysOpen"
      :defaultExpandLevel="defaultExpandLevel"
      :openDirection="openDirection"
      :clearable="clearable || true"
      :multiple="multiple"
      :disabled="disabled"
      :flat="flat"
      :disable-branch-nodes="disableBranchNodes"
      :maxHeight="200"
      @select="selectNode"
      @deselect="delSelect"
      @input="inputNode"
      :placeholder="$t('company.treeselect.searchIndex')"
      :noResultsText="$t('company.treeselect.noData')"
      :searchPromptText="$t('company.treeselect.searchIndex')"
    />
  </div>
</template>
<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      currentValue: {
        type: String,
        default: () => '',
      },
      model: {
        type: String,
        default: () => '',
      },
      apiUrl: {
        type: String,
        default: '',
      },
      apiData: {
        type: Object,
        default: () => {},
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      // 父子节点没有关联，每个节点都是单独的个体
      // 部门树：第一级子节点不可选：isDisabled=true
      flat: {
        type: Boolean,
        default: true,
      },
      //分支节点扩展
      defaultExpandLevel: {
        type: Number,
        default: () => Infinity,
      },
      clearable: {
        type: Boolean,
        default: () => false,
      },
      //是否需要name
      isName: {
        type: Boolean,
        default: () => false,
      },
      //返回类型
      returnType: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: () => false,
      },
      openDirection: {
        type: String,
        default: 'auto',
      },
      //校验方法
      normalizerFlag: {
        type: Boolean,
        default: () => false,
      },
      alwaysOpen: {
        type: Boolean,
        default: () => false,
      },
      trigger: {
        type: String,
        default: '',
      },
      // 是否为一行显示
      isLine: {
        type: Boolean,
        default: false,
      },
      disableBranchNodes: {
        type: Boolean,
        default: () => false,
      },
      //是否为空间资质
      isSpace: {
        type: Boolean,
        default: () => false,
      },
      filterData: {
        type: Function,
        default: (data) => {
          return data;
        },
      },
    },
    data() {
      return {
        departMentTree: [],
        spaceId: [],
        defaultValue: !this.currentValue || this.currentValue == 'null' ? null : this.currentValue,
        normalizer(node) {
          //只能选择根节点
          if (node.children) {
            node.children.map((item) => {
              item['isDisabled'] = true;
            });
          }
          return node;
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    created() {
      this.initDepartment();
    },
    watch: {
      // API() {
      //   this.initDepartment();
      // }
      apiData() {
        this.initDepartment();
      },
      //清空
      defaultValue(value) {
        if (value == undefined || !(value || []).length) {
          this.clearableValue();
        }
      },
      currentValue(newValue) {
        this.defaultValue = newValue || null;
      },
    },
    methods: {
      initDepartment() {
        this.$axios.post(this.apiUrl, this.apiData).then((res) => {
          if (0 == res.data.code) {
            this.departMentTree = this.filterData(res.data.data);
            this.getSelectedNode(this.departMentTree, this.departMentTree);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //删掉没有子节点的children
      getSelectedNode(nodeData) {
        nodeData.forEach((item) => {
          if ('children' in item && (item.children == null || item.children.length === 0)) {
            delete item.children;
          } else if ('children' in item && item.children.length) {
            this.getSelectedNode(item.children, item);
          }
        });
      },
      resetClick() {
        this.defaultValue = this.currentValue || null;
      },
      inputNode(value) {
        this.$emit('input', value);
        if (this.multiple && !this.isSpace) {
          // 多选，返回字符串
          let val = value.join(',') == '' ? null : value.join(',');
          this.$emit('setSearchModal', this.model, val);
        }
      },
      //清空
      clearableValue() {
        this.$emit('setSearchModal', this.model, null);
        this.spaceId = [];
      },
      selectNode(node) {
        if (!this.multiple) {
          if (this.returnType == '') {
            this.$emit('setSearchModal', this.model, this.isName ? node.label : node.id);
          } else {
            this.$emit('setSearchModal', this.model, node);
          }
        }
        if (this.isSpace) {
          this.dataStructure(node, 'add');
          this.$emit('setSearchModal', this.model, this.spaceId.toString());
        }
      },
      delSelect(node) {
        if (this.isSpace) {
          this.dataStructure(node, 'del');
          this.$emit('setSearchModal', this.model, this.spaceId.toString());
        }
      },
      dataStructure(data, type) {
        if (data.children && data.children.length) {
          data.children.forEach((item) => {
            this.dataStructure(item, type);
          });
        } else {
          if (type == 'add') {
            this.spaceId.push(data.id);
          } else {
            this.spaceId.forEach((item, index) => {
              if (data.id == item) {
                this.spaceId.splice(index, 1);
              }
            });
          }
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .tree-line {
    ::v-deep .vue-treeselect__multi-value {
      // display: flex !important;
      // overflow: hidden !important;
      // text-overflow: ellipsis !important;
      // white-space: nowrap !important;
      width: 100% !important;
      word-break: break-all !important;
      text-overflow: ellipsis !important;
      display: -webkit-box !important;
      -webkit-box-orient: vertical !important;
      -webkit-line-clamp: 1 !important;
      overflow: hidden !important;
    }
    ::v-deep .vue-treeselect__value-remove {
      display: none !important;
    }
  }
  .tree-select {
    ::v-deep .vue-treeselect__multi-value-item {
      background: #f4f4f5;
      color: #909399;
    }
    ::v-deep .vue-treeselect__value-remove {
      border-left: none;
      height: 14px;
      width: 15px;
      line-height: 13px;
      vertical-align: middle;
      border-radius: 50%;
      display: inline-block;
      background-color: #c0c4cc;
      color: #909399;
      margin-right: 5px;
    }
    ::v-deep .vue-treeselect__multi-value-item-container:hover .vue-treeselect__value-remove {
      color: #fff !important;
      background-color: #999;
    }
  }
</style>
